import React, { useState, useEffect } from "react"
import axios from 'axios';
import {
    Col,
    Form,
    FormGroup,
    Input,
    Row,
    Button,
    FormFeedback,
    InputGroup
} from "reactstrap"

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import PropTypes from 'prop-types';
import Flatpickr from "react-flatpickr";
import { rdDetailsUrl, getRDDetailsUrl } from "../../helpers/fakebackend_helper";
import authHeader from "helpers/authHeader";

const RD = ({ RegistrationId }) => {

    const formBackground = {
        borderRadius: 8,
        flex: 1,
        ////backgroundColor: "rgb(247 242 242)",
        padding: "15px"
    }

    const tabHeading = {
        color: "#9a084f",
        fontWeight: "bold"
    }

    const label = {
        color: "black"
    }

    const formMandatory = {
        color: "red",
        fontWeight: "bold"
    }

    const formButton = {
        marginLeft: "20px",
        backgroundColor: "#9a084f",
        fontSize: "small",
        borderRadius: "0.50rem"
    }

    $(".d-block").flatpickr({
        dateFormat: "d-M-Y",
        altFormat: "F j, Y",
        maxDate: "today",
        disableMobile: "true"
    });

    const [branch, setBranch] = useState([]);
    const [showEasing, setshowEasing] = useState("swing");
    const [hideEasing, sethideEasing] = useState("linear");
    const [showMethod, setshowMethod] = useState("fadeIn");
    const [hideMethod, sethideMethod] = useState("fadeOut");
    const [showDuration, setshowDuration] = useState(300);
    const [hideDuration, sethideDuration] = useState(1000);
    const [timeOut, settimeOut] = useState(2000);
    const [extendedTimeOut, setextendedTimeOut] = useState(1000);

    function SuccessMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.success(message, "Information");
    }

    function ErrorMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.error(message, "Error");
    }

    function autorenewalValidation(value) {
        debugger;
        validation.values.periodyearrd = "";
        validation.values.periodmonthrd = "";
        validation.values.perioddaysrd = "";

        const autorenewal = value.target.value;

        if (autorenewal != '') {
            if ($("#rbautorenewalyesrd").prop("checked")) {
                $("#txtperiodyearrd").prop('disabled', false);
                $("#txtperiodmonthrd").prop('disabled', false);
                $("#txtperioddaysrd").prop('disabled', false);
            }
            else if ($("#rbautorenewalnord").prop("checked")) {
                $("#txtperiodyearrd").prop('disabled', true);
                $("#txtperiodmonthrd").prop('disabled', true);
                $("#txtperioddaysrd").prop('disabled', true);
            }
        }
    }

    const [rdData, setRDData] = useState([]);

    // Form validation
    const validation = useFormik({

        enableReinitialize: true,

        initialValues: {

            depositamountrd: rdData.depositAmount == null ? '' : rdData.depositAmount,
            tenureyearrd: rdData.tenureYear == null ? '' : rdData.tenureYear,
            tenuremonthrd: rdData.tenureMonths == null ? '' : rdData.tenureMonths,
            tenuredaysrd: rdData.tenureDays == null ? '' : rdData.tenureDays,
            banknamerd: rdData.bankName == null ? '' : rdData.bankName,
            branchnamerd: rdData.branchName == null ? '' : rdData.branchName,
            accountnumberrd: rdData.accountNo == null ? '' : rdData.accountNo,
            ifscrd: rdData.ifsc == null ? '' : rdData.ifsc,
            periodyearrd: rdData.periodYear == null ? '' : $("#rbautorenewalnord").prop("checked") ? '' : rdData.periodYear,
            periodmonthrd: rdData.periodMonths == null ? '' : $("#rbautorenewalnord").prop("checked") ? '' : rdData.periodMonths,
            perioddaysrd: rdData.periodDays == null ? '' : $("#rbautorenewalnord").prop("checked") ? '' : rdData.periodDays,
            debitaccountno: rdData.debitAccountNo == null ? '' : rdData.debitAccountNo,
            rdamount: rdData.rdAmount == null ? '' : rdData.rdAmount,
            rdmonths: rdData.rdMonths == null ? '' : rdData.rdMonths,
        },
        validationSchema: Yup.object({
            depositamountrd: Yup.string().required("Deposit Amount required"),
            tenureyearrd: Yup.string().required("Years required"),
            tenuremonthrd: Yup.string().required("Months required"),
            tenuredaysrd: Yup.string().required("Days required"),
            banknamerd: Yup.string().required("Bank Name required").matches(/^[A-Za-z ]+$/, "Enter character only!"),
            branchnamerd: Yup.string().required("Branch Name required"),
            accountnumberrd: Yup.string().required("Account Number required"),
            ifscrd: Yup.string().required("IFSC required"),
            debitaccountno: Yup.string().required("Debit Account Number required"),
            rdamount: Yup.string().required("Amount required"),
            rdmonths: Yup.string().required("Number of Months required")
        }),
        onSubmit: (values) => {
            //console.log("values", values);
        }
    });

    function CheckIsValid(controlValues) {
        debugger;
        var x = Object.keys(controlValues[0])
        var isCheckIfUndefined = x.map(p => {
            if (controlValues[0][p] === "" || controlValues[0][p] === undefined) {
                return true
            }
            else
                return false
        })

        var checkResponse = isCheckIfUndefined.includes(true)
        return checkResponse
    }

    const rdDetails = {
        RegistrationId: '',
        DepositAmount: '',
        TenureYear: '',
        TenureMonths: '',
        TenureDays: '',
        InterestPayout: '',
        InterestPayoutMode: '',
        BankName: '',
        BranchName: '',
        AccountNo: '',
        IFSC: '',
        IsAutoRenewal: '',
        PeriodYear: '',
        PeriodMonths: '',
        PeriodDays: '',
        DebitAccountNo: '',
        RDAmount: '',
        RDMonths: ''
    }

    function chkNumeric(e) {
        let input = e.target.value;

        if (input == "") {
            validation.handleChange(e);
        }
        else if (typeof input !== "undefined") {
            var pattern = new RegExp(/^[0-9\b]+$/);
            if (pattern.test(input)) {
                validation.handleChange(e);
            }
        }
    }

    useEffect(() => {
        GetRDDetails();
    }, []);

    function BindRDDetails(rdDeails) {
        if (rdDeails.interestPayout != null) {
            if (rdDeails.interestPayout == "Monthly") {
                $('#rbmonthlyrd').prop('checked', true);
            }
            else if (rdDeails.interestPayout == "Quarterly") {
                $('#rbquarterlyrd').prop('checked', true);
            }
            else if (rdDeails.interestPayout == "Half Yearly") {
                $('#rbhalfyearlyrd').prop('checked', true);
            }
            else if (rdDeails.interestPayout == "Yearly") {
                $('#rbyearlyrd').prop('checked', true);
            }
        }

        if (rdDeails.interestPayoutMode != null) {
            if (rdDeails.interestPayoutMode == "Standing Instructions") {
                $('#rbstandinginstructionsrd').prop('checked', true);
            }
            else if (rdDeails.interestPayoutMode == "ECS") {
                $('#rbecsrd').prop('checked', true);
            }
            else if (rdDeails.interestPayoutMode == "Pay Order") {
                $('#rbpayorderrd').prop('checked', true);
            }
        }

        if (rdDeails.isAutoRenewal != null) {
            if (rdDeails.isAutoRenewal == true) {
                $('#rbautorenewalyesrd').prop('checked', true);
            }
            else if (rdDeails.isAutoRenewal == false) {
                $('#rbautorenewalnord').prop('checked', true);
            }
        }
    }

    function GetRDDetails() {
        debugger;
        const customerDetailModel = {
            RegistrationId: RegistrationId
        };

        axios.post(getRDDetailsUrl(), customerDetailModel, { headers: authHeader() })
            .then(response => {
                if (response.data.length > 0) {
                    BindRDDetails(response.data[0]);
                    setRDData(response.data[0]);

                    if ($("#rbautorenewalyesrd").prop("checked")) {
                        $("#txtperiodyearrd").prop('disabled', false);
                        $("#txtperiodmonthrd").prop('disabled', false);
                        $("#txtperioddaysrd").prop('disabled', false);
                    }
                    else if ($("#rbautorenewalnord").prop("checked")) {
                        $("#txtperiodyearrd").prop('disabled', true);
                        $("#txtperiodmonthrd").prop('disabled', true);
                        $("#txtperioddaysrd").prop('disabled', true);
                    }
                }
            }, (error) => {
                console.log(error.response);
            })
    }

    function SaveRDDetails(RegistrationId) {
        debugger;

        if ($("#rbautorenewalyesrd").prop("checked")) {
            if ($('#txtperiodyearrd').val().trim() == "") {
                ErrorMessage("Please enter Period Year");
                $('#txtperiodyearrd').focus();
                return;
            }
            else if ($('#txtperiodmonthrd').val().trim() == "") {
                ErrorMessage("Please enter Period Month");
                $('#txtperiodmonthrd').focus();
                return;
            }
            else if ($('#txtperioddaysrd').val().trim() == "") {
                ErrorMessage("Please enter Period Days");
                $('#txtperioddaysrd').focus();
                return;
            }
        }

        rdDetails.RegistrationId = RegistrationId;

        rdDetails.DepositAmount = $('#txtdepositamountrd').val().trim();
        rdDetails.TenureYear = $('#txttenureyearrd').val().trim();
        rdDetails.TenureMonths = $('#txttenuremonthrd').val().trim();
        rdDetails.TenureDays = $('#txttenuredaysrd').val().trim();
        if ($("#rbmonthlyrd").prop("checked")) {
            rdDetails.InterestPayout = "Monthly";
        }
        else if ($("#rbquarterlyrd").prop("checked")) {
            rdDetails.InterestPayout = "Quarterly";
        }
        else if ($("#rbhalfyearlyrd").prop("checked")) {
            rdDetails.InterestPayout = "Half Yearly";
        }
        else if ($("#rbyearlyrd").prop("checked")) {
            rdDetails.InterestPayout = "Yearly";
        }
        else if ($("#rbonmaturityrd").prop("checked")) {
            rdDetails.InterestPayout = "On Maturity";
        }

        if ($("#rbstandinginstructionsrd").prop("checked")) {
            rdDetails.InterestPayoutMode = "Standing Instructions";
        }
        else if ($("#rbecsrd").prop("checked")) {
            rdDetails.InterestPayoutMode = "ECS";
        }
        else if ($("#rbpayorderrd").prop("checked")) {
            rdDetails.InterestPayoutMode = "Pay Order";
        }

        rdDetails.BankName = $('#txtbanknamerd').val().trim();
        rdDetails.BranchName = $('#txtbranchnamerd').val().trim();
        rdDetails.AccountNo = $('#txtaccountnumberrd').val().trim();
        rdDetails.IFSC = $('#txtifscrd').val().trim();

        if ($("#rbautorenewalyesrd").prop("checked")) {
            rdDetails.IsAutoRenewal = "true";
        }
        else if ($("#rbautorenewalnord").prop("checked")) {
            rdDetails.IsAutoRenewal = "false";
        }

        if ($("#rbautorenewalyesrd").prop("checked")) {
            rdDetails.PeriodYear = $('#txtperiodyearrd').val().trim();
            rdDetails.PeriodMonths = $('#txtperiodmonthrd').val().trim();
            rdDetails.PeriodDays = $('#txtperioddaysrd').val().trim();
        }
        else {
            rdDetails.PeriodYear = "";
            rdDetails.PeriodMonths = "";
            rdDetails.PeriodDays = "";
        }
        rdDetails.DebitAccountNo = $('#txtdebitaccountno').val().trim();
        rdDetails.RDAmount = $('#txtrdamount').val().trim();
        rdDetails.RDMonths = $('#txtrdmonths').val().trim();

        axios.post(rdDetailsUrl(), rdDetails, { headers: authHeader() })
            .then(res => {
                if (res.data.responseCode == "OK") {
                    SuccessMessage(res.data.responseMessage);
                }
                else {
                    ErrorMessage(res.data.responseMessage);
                }
            })
    }

    return (
        <React.Fragment>
            <Row style={{ backgroundColor: "white" }}>
                <Col >
                    <div className="table-responsive">
                        <Form style={formBackground} className="needs-validation" onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}>
                            <Row>
                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Deposit Amount</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="depositamountrd"
                                            placeholder="Deposit Amount"
                                            type="text"
                                            className="form-control"
                                            id="txtdepositamountrd"
                                            maxLength="10"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.depositamountrd || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.depositamountrd &&
                                                    (validation.touched &&
                                                        validation.touched.depositamountrd) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.depositamountrd &&
                                                (validation.touched &&
                                                    validation.touched.depositamountrd) ? (
                                                <FormFeedback type="invalid">{validation.errors.depositamountrd}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>

                                <Col lg="2">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Tenure Year</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="tenureyearrd"
                                            placeholder="Years"
                                            type="text"
                                            className="form-control"
                                            id="txttenureyearrd"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.tenureyearrd || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.tenureyearrd &&
                                                    (validation.touched &&
                                                        validation.touched.tenureyearrd) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.tenureyearrd &&
                                                (validation.touched &&
                                                    validation.touched.tenureyearrd) ? (
                                                <FormFeedback type="invalid">{validation.errors.tenureyearrd}</FormFeedback>
                                            ) : null}

                                    </FormGroup>
                                </Col>

                                <Col lg="2">
                                    <label style={label}>Tenure Month</label><span style={formMandatory}>*</span>
                                    <FormGroup className="mb-4">
                                        <Input
                                            name="tenuremonthrd"
                                            placeholder="Months"
                                            type="text"
                                            className="form-control"
                                            id="txttenuremonthrd"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.tenuremonthrd || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.tenuremonthrd &&
                                                    (validation.touched &&
                                                        validation.touched.tenuremonthrd) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.tenuremonthrd &&
                                                (validation.touched &&
                                                    validation.touched.tenuremonthrd) ? (
                                                <FormFeedback type="invalid">{validation.errors.tenuremonthrd}</FormFeedback>
                                            ) : null}

                                    </FormGroup>
                                </Col>

                                <Col lg="2">
                                    <label style={label}>Tenure Days</label><span style={formMandatory}>*</span>
                                    <FormGroup className="mb-4">
                                        <Input
                                            name="tenuredaysrd"
                                            placeholder="Days"
                                            type="text"
                                            className="form-control"
                                            id="txttenuredaysrd"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.tenuredaysrd || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.tenuredaysrd &&
                                                    (validation.touched &&
                                                        validation.touched.tenuredaysrd) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.tenuredaysrd &&
                                                (validation.touched &&
                                                    validation.touched.tenuredaysrd) ? (
                                                <FormFeedback type="invalid">{validation.errors.tenuredaysrd}</FormFeedback>
                                            ) : null}

                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <label style={label}>Interest Payout</label>
                                <Col lg="1">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestpayout"
                                            id="rbmonthlyrd"
                                            value="option1"
                                            defaultChecked
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Monthly
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="1">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestpayout"
                                            id="rbquarterlyrd"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Quarterly
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="1">
                                    <div className="form-check mb-3" style={{ width: "110%" }}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestpayout"
                                            id="rbhalfyearlyrd"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Half Yearly
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="1">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestpayout"
                                            id="rbyearlyrd"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Yearly
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="2">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestpayout"
                                            id="rbonmaturityrd"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            On Maturity
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <label style={label}>Mode of Interest</label>
                                <Col lg="2">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestmode"
                                            id="rbstandinginstructionsrd"
                                            value="option1"
                                            defaultChecked
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Standing Instructions
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="1">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestmode"
                                            id="rbecsrd"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            ECS
                                        </label>
                                    </div>
                                </Col>

                                <Col lg="2">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="interestmode"
                                            id="rbpayorderrd"
                                            value="option1"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="exampleRadios1"
                                        >
                                            Pay Order
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Details of bank account in which interest payout/amount payable on maturity desired to be deposited</label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Bank Name</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="banknamerd"
                                            placeholder="Bank Name"
                                            type="text"
                                            className="form-control"
                                            id="txtbanknamerd"
                                            maxLength="100"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.banknamerd || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.banknamerd &&
                                                    (validation.touched &&
                                                        validation.touched.banknamerd) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.banknamerd &&
                                                (validation.touched &&
                                                    validation.touched.banknamerd) ? (
                                                <FormFeedback type="invalid">{validation.errors.banknamerd}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>

                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Branch Name</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="branchnamerd"
                                            placeholder="Branch Name"
                                            type="text"
                                            className="form-control"
                                            id="txtbranchnamerd"
                                            maxLength="100"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.branchnamerd || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.branchnamerd &&
                                                    (validation.touched &&
                                                        validation.touched.branchnamerd) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.branchnamerd &&
                                                (validation.touched &&
                                                    validation.touched.branchnamerd) ? (
                                                <FormFeedback type="invalid">{validation.errors.branchnamerd}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>

                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Account Number</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="accountnumberrd"
                                            placeholder="Account Number"
                                            type="text"
                                            className="form-control"
                                            id="txtaccountnumberrd"
                                            maxLength="20"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.accountnumberrd || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.accountnumberrd &&
                                                    (validation.touched &&
                                                        validation.touched.accountnumberrd) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.accountnumberrd &&
                                                (validation.touched &&
                                                    validation.touched.accountnumberrd) ? (
                                                <FormFeedback type="invalid">{validation.errors.accountnumberrd}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>IFSC</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="ifscrd"
                                            placeholder="IFSC"
                                            type="text"
                                            className="form-control"
                                            id="txtifscrd"
                                            maxLength="20"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.ifscrd || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.ifscrd &&
                                                    (validation.touched &&
                                                        validation.touched.ifscrd) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.ifscrd &&
                                                (validation.touched &&
                                                    validation.touched.ifscrd) ? (
                                                <FormFeedback type="invalid">{validation.errors.ifscrd}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>
                                <Col lg="2">
                                    <label style={label}>Auto renewal</label>
                                    <Col lg="3" style={{ display: "flex", marginTop: "10px" }}>
                                        <div className="form-check mb-3">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="autorenewal"
                                                id="rbautorenewalyesrd"
                                                value="option1"
                                                onClick={e => { autorenewalValidation(e); validation.handleChange(e) }}
                                                defaultChecked
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="exampleRadios1"
                                            >
                                                Yes
                                            </label>
                                        </div>

                                        <div className="form-check mb-3" style={{ marginLeft: "10px" }}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="autorenewal"
                                                id="rbautorenewalnord"
                                                value="option1"
                                                onClick={e => { autorenewalValidation(e); validation.handleChange(e) }}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="exampleRadios1"
                                            >
                                                No
                                            </label>
                                        </div>
                                    </Col>
                                </Col>
                                <Col lg="2">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Period Year</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="periodyearrd"
                                            placeholder="Years"
                                            type="text"
                                            className="form-control"
                                            id="txtperiodyearrd"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.periodyearrd || ""}
                                            autoComplete="off"
                                        />
                                    </FormGroup>
                                </Col>

                                <Col lg="2">
                                    <label style={label}>Period Month</label><span style={formMandatory}>*</span>
                                    <FormGroup className="mb-4">
                                        <Input
                                            name="periodmonthrd"
                                            placeholder="Months"
                                            type="text"
                                            className="form-control"
                                            id="txtperiodmonthrd"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.periodmonthrd || ""}
                                            autoComplete="off"
                                        />
                                    </FormGroup>
                                </Col>

                                <Col lg="2">
                                    <label style={label}>Period Days</label><span style={formMandatory}>*</span>
                                    <FormGroup className="mb-4">
                                        <Input
                                            name="perioddaysrd"
                                            placeholder="Days"
                                            type="text"
                                            className="form-control"
                                            id="txtperioddaysrd"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.perioddaysrd || ""}
                                            autoComplete="off"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <label style={label}>Instructions for deduction of RD installment</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Debit SB/CA/CC/ A/c Number</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="debitaccountno"
                                            placeholder="Debit Account Number"
                                            type="text"
                                            className="form-control"
                                            id="txtdebitaccountno"
                                            maxLength="20"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.debitaccountno || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.debitaccountno &&
                                                    (validation.touched &&
                                                        validation.touched.debitaccountno) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.debitaccountno &&
                                                (validation.touched &&
                                                    validation.touched.debitaccountno) ? (
                                                <FormFeedback type="invalid">{validation.errors.debitaccountno}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>

                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Amount</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="rdamount"
                                            placeholder="Amount"
                                            type="text"
                                            className="form-control"
                                            id="txtrdamount"
                                            maxLength="10"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.rdamount || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.rdamount &&
                                                    (validation.touched &&
                                                        validation.touched.rdamount) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.rdamount &&
                                                (validation.touched &&
                                                    validation.touched.rdamount) ? (
                                                <FormFeedback type="invalid">{validation.errors.rdamount}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>

                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Number of Months</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="rdmonths"
                                            placeholder="Number of Months"
                                            type="text"
                                            className="form-control"
                                            id="txtrdmonths"
                                            maxLength="2"
                                            onChange={e => { chkNumeric(e) }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.rdmonths || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.rdmonths &&
                                                    (validation.touched &&
                                                        validation.touched.rdmonths) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.rdmonths &&
                                                (validation.touched &&
                                                    validation.touched.rdmonths) ? (
                                                <FormFeedback type="invalid">{validation.errors.rdmonths}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="1">

                                </Col>
                                <Col lg="10">
                                </Col>
                                <Col lg="1">
                                    <Button id="firstN" style={formButton} type="submit"
                                        onClick={() => {
                                            let isEmpty = CheckIsValid([{
                                                depositamountrd: validation.values.depositamountrd,
                                                tenureyearrd: validation.values.tenureyearrd,
                                                tenuremonthrd: validation.values.tenuremonthrd,
                                                tenuredaysrd: validation.values.tenuredaysrd,
                                                banknamerd: validation.errors.banknamerd == undefined ? validation.values.banknamerd : "",
                                                branchnamerd: validation.values.branchnamerd,
                                                accountnumberrd: validation.values.accountnumberrd,
                                                ifscrd: validation.values.ifscrd,
                                                debitaccountno: validation.values.debitaccountno,
                                                rdamount: validation.values.rdamount,
                                                rdmonths: validation.values.rdmonths
                                            }])
                                            if (!isEmpty)
                                                SaveRDDetails(RegistrationId);
                                        }} >
                                        Save
                                    </Button>
                                </Col>
                            </Row>

                            <Row>
                            </Row>
                        </Form>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
};

RD.propTypes = {
    RegistrationId: PropTypes.string
}

export default RD
